import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-my-balance',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './my-balance.component.html',
  styleUrl: './my-balance.component.scss'
})
export class MyBalanceComponent {
  showModal = false;
  balance = { amount: 10, expiryDate: '23.03.2026' };
  packages = [
    { id: 1, name: "10 elan paket", price: 29, duration: 30, count: 10 },
    { id: 2, name: "50 elan paket", price: 69, duration: 30, count: 50 },
    { id: 3, name: "100 elan paket", price: 99, duration: 30, count: 100 }
  ];
  selectedPackage: any = null;

  pay() {
    alert(`Ödəniş uğurla tamamlandı! Paket: ${this.selectedPackage.name}`);
    this.showModal = false;
  }
}
